import styled from 'styled-components';
import { ReservePriceSection, SectionTitle } from '../../components';
import { Divider, Grid } from '@material-ui/core';
import { ActionButton } from '../../../../../components/ActionButton';
import { formatCurrency } from 'utils';
import { useDispatch, useSelector } from 'react-redux';
import { modalsHide, modalsToggle } from '../../../../../actions';
import EditVehicleBidModal from '../../../../Seller/VehicleSales/components/EditVehicleBidModal';
import ConfirmModal from '../../../../../components/Modals/ConfirmModal';
import { useAcceptAlternativeBidOfferMutation } from '../../../../../services/api/alternative-offers';
import { setFocusField } from '../../../../../services/mySales/salesSlice';
import { auctionOfferStatuses } from '../../../../../utils/statusCalculator';
import { SELLER_VEHICLE_STATUS } from '../../../../../constants';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  & > div > p {
    margin: 0;
  }
`;

const StyledDivider = styled(Divider)`
  && {
    margin: 24px 0;
  }
`;

export const AlternativeAuctionComponent = ({ vehicle }) => {
  const alternativeOffer = vehicle.active_alternative_offer;
  const buyerAlternativeOffer = vehicle.top_alternative_bid_offer;
  const counterDisabled = vehicle.in_battle;

  const user = useSelector(state => state.user.user);
  const status = auctionOfferStatuses(vehicle, null, user);

  const dispatch = useDispatch();

  const openModal = () => {
    if (counterDisabled) {
      return;
    }

    dispatch(setFocusField('alternative_offer'));
    dispatch(modalsToggle(`vehicleEditModal-${vehicle.id}`));
  };

  const openAcceptModal = () => {
    dispatch(modalsToggle(`accept-alternative-offer-${vehicle.id}`));
  };

  if ([SELLER_VEHICLE_STATUS.TIME_ENDED, SELLER_VEHICLE_STATUS.ADMIN_ACTION_REQUIRED].includes(status)) {
    return null;
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <ReservePriceSection vehicle={vehicle} includeDivider />
      </Grid>
      <Wrapper>
        <Grid item xs={12} sm={8}>
          <SectionTitle>{`Your counter: ${
            alternativeOffer ? formatCurrency(alternativeOffer.amount) : 'N/A'
          }`}</SectionTitle>
          <EditVehicleBidModal
            form={`vehicleEditModal-${vehicle.id}`}
            initialValues={{ ...vehicle, alternative_offer: vehicle.active_alternative_offer?.amount }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ActionButton disabled={counterDisabled} onClick={openModal} colorVariant="counter" fullWidth>
            Update Counter
          </ActionButton>
        </Grid>
      </Wrapper>
      <Grid item xs={12}>
        <StyledDivider />
      </Grid>
      <Wrapper>
        <Grid item xs={12} sm={8}>
          <SectionTitle>{`Buyer Offer: ${
            buyerAlternativeOffer ? formatCurrency(buyerAlternativeOffer.amount) : 'N/A'
          }`}</SectionTitle>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ActionButton
            disabled={!buyerAlternativeOffer || vehicle.in_battle}
            onClick={openAcceptModal}
            colorVariant="accept"
            fullWidth
          >
            Accept Offer
          </ActionButton>
          <ConfirmAcceptBuyerOfferModal vehicleId={vehicle.id} offerAmount={buyerAlternativeOffer?.amount} />
        </Grid>
      </Wrapper>
    </Grid>
  );
};

export const ConfirmAcceptBuyerOfferModal = ({ vehicleId, offerAmount }) => {
  const [acceptMutation] = useAcceptAlternativeBidOfferMutation();
  const dispatch = useDispatch();
  const handleSubmit = async () => {
    await acceptMutation(vehicleId);
    dispatch(modalsHide(`accept-alternative-offer-${vehicleId}`));
  };

  return (
    <ConfirmModal
      title={`Are you sure you want to accept buyer's offer? Vehicle will be sold for ${offerAmount}`}
      handleSubmit={handleSubmit}
      submitText={'Accept'}
      modalId={`accept-alternative-offer-${vehicleId}`}
    />
  );
};
